module.exports = __webpack_public_path__ + "static/tutoring-62cd7a2f142580e075515fe5a5870d79.jpg";